/**
 * when which order item has time reserved in which time table
 *
 * created by OrderCalculator#getProductionSchedule and stored on the order —
 * the constructors hydrate raw data (firestore timestamps, iso strings) back
 * into real dates and typed instances
 */
function toDate(value) {
    if (!value) {
        return null;
    }
    //firebase timestamps
    if (value.seconds !== undefined && value.toDate) {
        return value.toDate();
    }
    if (value.seconds !== undefined) {
        return new Date(value.seconds * 1000);
    }
    let date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
//a chunk of reserved time inside one time table window
export class ScheduleWindow {
    start = null;
    end = null;
    minutes = 0;
    constructor(data) {
        if (!data) {
            return;
        }
        this.start = toDate(data.start);
        this.end = toDate(data.end);
        this.minutes = data.minutes || 0;
    }
}
//one production (or delivery) step: a duration reserved in one time table
export class ScheduleStep {
    timeTableId = '';
    source = 'product';
    minutes = 0;
    startDate = null;
    endDate = null;
    windows = [];
    constructor(data) {
        if (!data) {
            return;
        }
        this.timeTableId = data.timeTableId || '';
        this.source = data.source || 'product';
        this.minutes = data.minutes || 0;
        this.startDate = toDate(data.startDate);
        this.endDate = toDate(data.endDate);
        this.windows = Array.isArray(data.windows) ? data.windows.map((window) => new ScheduleWindow(window)) : [];
    }
}
export class ScheduleItem {
    cartItemId = null;
    productId = null;
    productName = null;
    quantity = 1;
    steps = [];
    productionEndDate = null;
    constructor(data) {
        if (!data) {
            return;
        }
        this.cartItemId = data.cartItemId || null;
        this.productId = data.productId || null;
        this.productName = data.productName || null;
        this.quantity = data.quantity || 1;
        this.steps = Array.isArray(data.steps) ? data.steps.map((step) => new ScheduleStep(step)) : [];
        this.productionEndDate = toDate(data.productionEndDate);
    }
}
export class ProductionSchedule {
    calculatedAt = null;
    items = [];
    productionEndDate = null;
    firstPossiblePickupDate = null;
    firstPossibleDeliveryDate = null;
    deliveryStep = null;
    constructor(data) {
        if (!data) {
            return;
        }
        this.calculatedAt = toDate(data.calculatedAt);
        this.items = Array.isArray(data.items) ? data.items.map((item) => new ScheduleItem(item)) : [];
        this.productionEndDate = toDate(data.productionEndDate);
        this.firstPossiblePickupDate = toDate(data.firstPossiblePickupDate);
        this.firstPossibleDeliveryDate = toDate(data.firstPossibleDeliveryDate);
        this.deliveryStep = data.deliveryStep ? new ScheduleStep(data.deliveryStep) : null;
    }
}
